import * as Utilities from '../utilities'

export default {
    name: 'en',
    messages: {
        min_dimensions: (field, [width, height]) => `The ${field} field must be at least ${width} pixels by ${height} pixels.`,
        max_dimensions: (field, [width, height]) => `The ${field} field must be at no more than ${width} pixels by ${height} pixels.`,
        min_size: (field, [size]) => `The ${field} field must me at least ${Utilities.formatFileSize(size)}`,
    }
};